import config from "../../config.json";
const BASE_AUTH_API = config.BASE_AUTH_API;

// HISTORICAL StoreOnboarding records (Phase 4): READ-ONLY. The old quotation / payment / approval calls were removed with the workflow
// (the server answers 410 for them). The client's onboarding is /store-onboarding/stores/* (utils/api/storeOnboardingDraft.js) and
// subscriptions / payments are in utils/api/billing.js.

export const apiRequest = async ({ endpoint, method = "GET", token, body }) => {
  try {
    const response = await fetch(`${BASE_AUTH_API}${endpoint}`, {
      method,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      ...(body && {
        body: JSON.stringify(body),
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Request failed");
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getStoreOnboardingAdminAPI = async (
  token,
  page = 1,
  limit = 20,
) => {
  const res = await apiRequest({
    endpoint: `store-onboarding/admin?page=${page}&limit=${limit}`,
    token,
  });

  return res;
};

export const getStoreOnboardingFileUrlAPI = async (
  token,
  onboardingId,
  params,
) => {
  const query = new URLSearchParams(params).toString();

  const response = await fetch(
    `${BASE_AUTH_API}store-onboarding/${onboardingId}/file-url?${query}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to get file url");
  }

  return data.url;
};
